module.exports = __webpack_public_path__ + "static/media/4@3x.aa6cd3f1.png";